import { insightsIntl } from "../strings/intl";

export enum PaidChannel {
  META_ADS = "META_ADS",
  GOOGLE_ADS = "GOOGLE_ADS",
}

export const paidChannelStrings: Record<PaidChannel, { description: string }> = {
  [PaidChannel.META_ADS]: {
    description: insightsIntl.formatMessage({ id: "Meta", defaultMessage: "Meta" }),
  },
  [PaidChannel.GOOGLE_ADS]: {
    description: insightsIntl.formatMessage({ id: "Google", defaultMessage: "Google" }),
  },
};

export const PAID_CHANNELS_SUMMARY = "PAID_CHANNELS_SUMMARY";
